import { render } from "./cinemaGoods.vue?vue&type=template&id=494c55c8&scoped=true"
import script from "./cinemaGoods.vue?vue&type=script&lang=js"
export * from "./cinemaGoods.vue?vue&type=script&lang=js"

import "./cinemaGoods.vue?vue&type=style&index=0&id=494c55c8&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494c55c8"]])

export default __exports__